/**
 * reorder returns a reordered version of the inputed list by swapping the element
 * at startIndex with the one at endIndex
 */
export function reorder<A>(list: A[], startIndex: number, endIndex: number): A[] {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}
